import React from 'react';
import { Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { CalendarProvider } from '../../utils/common';
import { SyncRuleFormValues } from '../sync_rule/interface';
import { calendarUUIDToProvider } from '../sync_rule/calendarOptions';
import { Account } from '../AccountCard';
import { SyncRuleAdvancedSettings } from '../sync_rule/SyncRuleAdvancedSettings';

export const OnboardingAdvancedSettings: React.FC<{
    form: UseFormReturnType<SyncRuleFormValues>;
    accounts: Account[];
}> = ({ form, accounts }) => {
    const { t } = useTranslation(['app']);
    const isDestinationColourCompatible = form.values.destination
        ? calendarUUIDToProvider(accounts, form.values.destination) === CalendarProvider.GOOGLE
        : false;

    return (
        <Stack gap="lg">
            <Stack gap="xs">
                <Text size="xl" fw={600}>{t('dashboard.onboarding.step6.title')}</Text>
                <Text c="dimmed">{t('dashboard.onboarding.step6.description')}</Text>
            </Stack>
            <SyncRuleAdvancedSettings
                form={form}
                isDestinationColourCompatible={isDestinationColourCompatible}
            />
        </Stack>
    );
};
